import { Injectable,Component } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';
export class personalinformation {
  StudentID:number; 
  StudentName:string;  
  PreStudentPhyInfoID:number;
  AcademicInstanceID:number;
  PRNNO:string; 
  StudentSexCode:string;
  StudentBirthDate:string;
  BirthYear:number;
  TypingEnglish:string;
  TypingMotherTongue:string;
  MSCITTypingSteno:string;
  MSCIT:string;
  Medical:string;
  TypingEnglishCertPath:string;
  BloodGroupID:number;
  TypingLanguageMotherTongue:string;
  TypingMotherTongueSpeed:number;
  TypingEnglishSpeed:number;
  TypingSteno:string;
  StenoSpeed:number;
  MSCITCertYear:number;
  MSCITCertGrade:string; 
  Studentht:number; 
  Studentwt:number; 
  Studentchest:number; 
  StudentCourseID:number;
  MotherTongue:string;
  DeleteFlag:string;
  CreatedDate:string;
  CreatedLoginID:number;
  UpdatedDate:string;
  UpdatedLoginID:number; 
  DocumentsList:DocumentsList;
}

export class DocumentsList {
  PreStudentPhyInfoID:number;
  CertId:number; 
  CertName:string;  
  CertPath:string;  
  disableUploadDoc:boolean;  
  viewdisable:boolean;  
  checkedValue:boolean;  
  ShowCertificate:boolean;   
}

export class BloodGroup {
  BloodGroupID:number;
  BloodGroupName:string;
}

@Injectable({
  providedIn: 'root'
})
export class PhysicalcertificateService {

  constructor(private dataService: DataAccessService) { }
  public PhysicalcertificateData: PhysicalcertificateService;
  
  public GetPersonalInformation(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetPreStudentInformationListByID?StudentID='+ StudentID + ""; // setting method name from API controller.
    return this.dataService.getAll<personalinformation[]>()
  } 
  public GetBasicBloodGroupsList(BloodGroupID) {
    this.dataService.setControllerName = '/BasicBloodGroups/';
    this.dataService.setMethodName = 'GetBasicBloodGroupsList?BloodGroupID='+ BloodGroupID + ""; // setting method name from API controller.
    return this.dataService.getAll<BloodGroup[]>()
  } 
  public GetPreStudentInformationForPhysicalInfo(CollegeID, CoursePartID, BranchID, CourseID, AcademicInstanceID, PreStudentPhyInfoID, StudentID) {
    debugger;
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'GetPreStudentInformationForPhysicalInfo?CollegeID='+ CollegeID +'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&CourseID='+CourseID+'&AcademicInstanceID='+AcademicInstanceID+'&PreStudentPhyInfoID='+PreStudentPhyInfoID+'&StudentID='+StudentID ; 
    return this.dataService.getAll<personalinformation[]>()
  } 
  public GetPreStudentInformationForPhysicalInfoDocument(PreStudentPhyInfoID, StudentID) {
    debugger;
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'GetPreStudentInformationForPhysicalInfoDocument?PreStudentPhyInfoID='+ PreStudentPhyInfoID + '&StudentID='+StudentID ; 
    return this.dataService.getAll<personalinformation[]>()
  } 
  
  public GetStudentInformationForPhysicalInfoStudentPortal(CollegeID, CoursePartID, BranchID, CourseID, AcademicInstanceID, PreStudentPhyInfoID, StudentID) {
    debugger;
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'GetStudentInformationForPhysicalInfoStudentPortal?CollegeID='+ CollegeID +'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&CourseID='+CourseID+'&AcademicInstanceID='+AcademicInstanceID+'&PreStudentPhyInfoID='+PreStudentPhyInfoID+'&StudentID='+StudentID ; 
    return this.dataService.getAll<personalinformation[]>()
  } 
  public PostInsertPhysicalInfo(data) {debugger
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'PostInsertPhysicalInfo'; 
    return this.dataService.add<personalinformation[]>(data) 
  }
  public UpdatePhysicalInfo(data) {debugger
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'PostPhysicalInfo'; 
    return this.dataService.add<personalinformation[]>(data) 
  }
  public PostDeletePhysicalInfo(data) {debugger
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'PostDeletePhysicalInfo'; 
    return this.dataService.add<personalinformation[]>(data) 
  }
  public PostRemovedPhyInfoCertificate(data) {debugger
    this.dataService.setControllerName = '/StudentPhyInfo/';
    this.dataService.setMethodName = 'PostRemovedPhyInfoCertificate'; 
    return this.dataService.add<personalinformation[]>(data) 
  }
}
